import { useState, useEffect } from "react";
import ButtonIcon from "../../components/ButtonIcon";
import { userData, selectedOptic } from "../../js/utils";
import DataGridView from "../components/DataGridView";
import { post } from "../utils/api";

import "../css/PerfilesControlInformacion.css";
import ProfilesScreen from "../components/ProfilesScreen";

const tokenSesion = userData ? userData.token : "";

let columnsData = [
  { name: "Id", accessor: "id", width: "60px", sortable: true },
  {
    name: "Nombre del perfil",
    accessor: "nombre",
    width: "1fr",
    sortable: true,
  },
  {
    name: "Ópticas vinculadas",
    accessor: "opticas",
    width: "2fr",
    sortable: false,
  },
];

export default function PerfilesControlInformacion(props) {
  const [profilesList, setProfilesList] = useState([]);
  const [idPerfil, setIdPerfil] = useState(-1);
  const [isProfileScreenOpen, setIsProfileScreenOpen] = useState(false);

  async function obtenerPerfiles() {
    // setIsLoading(true);
    let datosPerfiles = [];
    let json_perfiles = [];
    let jsonQuery = { token: tokenSesion, idOptica: selectedOptic.id };

    json_perfiles = await post("Configuracion/ListarPerfiles.php", jsonQuery);

    if (Array.isArray(json_perfiles)) {
      for (const el of json_perfiles) {
        let perfil = {
          id: el.id,
          nombre: el.nombre,
          opticas: el.opticas,
        };

        datosPerfiles.push(perfil);
      }
      console.log("DATOS CARGADOS: ", datosPerfiles);
      setProfilesList(datosPerfiles);
    }
  }

  useEffect(() => {
    obtenerPerfiles();
  }, []);

  const newProfile = () => {
    setIdPerfil(-1);
    setIsProfileScreenOpen(true);
  };

  const openProfilePopup = (row) => {
    setIdPerfil(row.id);
    setIsProfileScreenOpen(true);
  };

  const closeProfile = () => {
    setIsProfileScreenOpen(false);
  };

  if (!props.show) {
    return <></>;
  }

  return (
    <>
      <div className="settings-body-container">
        <div className="empresas-opticas">
          <span className="title-h2">
            Configuración de perfiles de control de la información
          </span>
          <div className="empresas-opticas-options">
            <div className="general-header-separator" />
            <ButtonIcon
              text="Nuevo perfil"
              icon="/images/add-white.svg"
              onClick={() => {
                newProfile();
              }}
            />
          </div>
        </div>
        <DataGridView
          columns={columnsData}
          data={profilesList}
          onRowClick={openProfilePopup}
          keyField="id"
          itemsIncrement="20"
        />
      </div>
      {isProfileScreenOpen && (
        <ProfilesScreen
          {...props}
          show={isProfileScreenOpen}
          closeFunction={closeProfile}
          profileId={idPerfil}
          onSave={(newId) => {
            if (newId) setIdPerfil(newId);
            obtenerPerfiles();
          }}
          onDelete={() => {
            obtenerPerfiles();
          }}
        />
      )}
    </>
  );
}
